import { NormalizedCacheObject } from 'apollo-cache-inmemory'
import ApolloClient from 'apollo-client'

import { ShouldTrackMutationPredicates } from './subscriptionsMutationsMap.types'

export const getShouldTrackMutationPredicates = (
  getClient: () => ApolloClient<NormalizedCacheObject> | undefined
): ShouldTrackMutationPredicates => {
  return {
    deleteSharePermanently: true,
    emptyWorkspaceTrash: true,
    shareDelete: true,
    shareRestore: true,
  }
}
